import React from 'react';
import PropTypes from 'prop-types';
import { VIEWS } from '../UpsertAccountModalConstants';
import { Wrapper, Title, ListItem, BackButton } from './AddAccountStyles';
import { OwnerTypeDTO } from '../../Profile/Accounts/api/useAccountsQuery';

const AddAccountView = ({
  visibleAccountTypesStack,
  pushVisibleAccountTypes,
  popVisibleAccountTypes,
  setCurrentView,
  setFocusedAccount,
  defaultPrincipalOwner,
}) => {
  const visibleAccountTypes =
    visibleAccountTypesStack.length > 0
      ? visibleAccountTypesStack[visibleAccountTypesStack.length - 1]
      : [];

  return (
    <Wrapper>
      {visibleAccountTypesStack.length > 1 && (
        <BackButton onClick={popVisibleAccountTypes}>Back</BackButton>
      )}

      <Title>Select an account</Title>

      {visibleAccountTypes.map(accountType => (
        <ListItem
          onClick={() => {
            if (accountType.subTypes) {
              pushVisibleAccountTypes(accountType.subTypes);
            } else {
              const newAccount = accountType.isAsset
                ? {
                    Owner: defaultPrincipalOwner,
                    OtherAssetType: accountType.type,
                    OwnerModel: [
                      {
                        Id: null,
                        Name: defaultPrincipalOwner,
                        OwnerType: OwnerTypeDTO.Principal,
                        Percentage: 1,
                      },
                    ],
                  }
                : {
                    AccountOwner: defaultPrincipalOwner,
                    AccountType: accountType.type,
                    OwnerModel: [
                      {
                        Id: null,
                        Name: defaultPrincipalOwner,
                        OwnerType: OwnerTypeDTO.Principal,
                        Percentage: 1,
                      },
                    ],
                  };

              setFocusedAccount(newAccount, { isNew: true });

              setCurrentView(VIEWS.EDIT);
            }
          }}
        >
          {accountType.name}
        </ListItem>
      ))}
    </Wrapper>
  );
};

AddAccountView.propTypes = {
  visibleAccountTypesStack: PropTypes.arrayOf(PropTypes.array).isRequired,
  pushVisibleAccountTypes: PropTypes.func.isRequired,
  popVisibleAccountTypes: PropTypes.func.isRequired,
  setCurrentView: PropTypes.func.isRequired,
  setFocusedAccount: PropTypes.func.isRequired,
  defaultPrincipalOwner: PropTypes.string.isRequired,
};

export default AddAccountView;
